import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { Logger, LoggingService, LogLevel } from '../logging/logging.service';

@Injectable({
    providedIn: 'root',
})
export class MemberGuardService {
    protected readonly authService = inject(CurafidaAuthService);
    private readonly router = inject(Router);
    private readonly loggingService = inject(LoggingService);
    protected readonly log: Logger = this.loggingService.getLogger(this.constructor.name);

    constructor() {
        this.log.setLevel(LogLevel.INFO);
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<UrlTree | boolean> {
        /*
         * An expired access token alone does not mean the user is logged out: after the app was
         * reopened the stored token has usually expired while a refresh is on its way, and sending
         * that session to /login left the user there even after the refresh succeeded.
         */
        if (this.authService.isAuthenticated() || (await this.authService.ensureFreshToken('member guard'))) {
            this.log.debug(`[canActivate] User is authenticated. Accessing /member/* is allowed. Return true.`);
            return true;
        }

        this.log.info(`[canActivate] User is NOT authenticated. Navigate to login page`);
        return this.router.createUrlTree(['login'], { queryParams: { redirect: state.url } });
    }
}
